import { ISoftData, ICategorys } from "@/common/interface";
import { IIndexState } from "@/store/index";
import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import SoftCell from "../../common/SoftCell";
import { useInViewport } from "ahooks";
import { sendClkLog } from "@/common/selfMonitor";
import { comMonitor, replaceUrlTemplate } from "@/utils/com";

import "./index.scss";

interface IProps {
  data: ISoftData[];
}

interface IItemProps {
  data: ISoftData;
}

const RecommendItem = (props: IItemProps) => {
  const {
    data: { clktk },
  } = props;
  const [startTime, setStartTime] = useState(0);
  const onMouseDown = (e: React.MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();
    setStartTime(Date.now());
  };

  const onMouseUp = (e: React.MouseEvent) => {
    if (Array.isArray(clktk) && clktk.length) {
      const now = Date.now();
      clktk.forEach((url) => {
        const realUrl = replaceUrlTemplate(url, e, startTime, now);
        comMonitor(realUrl);
      });
    }
  };
  return (
    <li
      onMouseDown={onMouseDown}
      onMouseUp={onMouseUp}
      className="recommend__item"
    >
      <SoftCell
        position="mainspecial1"
        className="soft-cell--lg"
        data={props.data}
        showBtn={true}
        supportLink={true}
      />
    </li>
  );
};

const Recommend = (props: IProps) => {
  const { data } = props;
  const items = data.map((item, index) => (
    <RecommendItem
      key={`${item.category}_${item.soft_id || index}`}
      data={item}
    />
  ));
  const nodeRef = useRef<HTMLUListElement>(null);
  const [lock, setLock] = useState(false);
  const [inViewport, ratio] = useInViewport(nodeRef, {
    threshold: [0.1, 0.5, 1],
  });

  useEffect(() => {
    if (inViewport && !lock && ratio && ratio >= 0.1 && data[0].soft_id) {
      const monitorIds = data
        .reduce<string>((prev, current) => {
          return (
            prev +
            "|" +
            `${current.soft_id}$${current.name}$${
              current.category && current.category.length
                ? ICategorys[current.category]
                : ICategorys[1]
            }`
          );
        }, "")
        .slice(1);

      const params = {
        cid: `mainspecial1`, //事件名称组名
        // c : "下载", //事件名称
        // from: (category && category.length) ? ICategorys[category] : '',
        title: monitorIds,
      };
      sendClkLog(params, "track");
      setLock(true);

      const urlItems = data.filter((item) => {
        return item.imptk;
      });
      urlItems.forEach((item) => {
        item.imptk.forEach((img: string) => {
          comMonitor(img);
        });
      });
    }
  }, [inViewport, data, lock, ratio]);

  return (
    <ul ref={nodeRef} className="recommend" data-bk="recommend">
      {items}
    </ul>
  );
};

const mapStateToProps = ({ indexData: { special1 } }: IIndexState) => ({
  data: special1,
});

export default connect(mapStateToProps)(Recommend);
